"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m9.1188 3 5.5308 5.6629-1.4064 1.4278-5.5525-5.685L9.1187 3zm.2024 11.0727.8434-.8563-4.4574-4.4746-1.4142 1.4197 4.5 4.5174.5662-.5684-.038-.0378zM5.293 6.648l5.7026 5.7247 1.4063-1.4278-5.6947-5.7167L5.293 6.648z"
  }), _react.default.createElement("path", {
    d: "M4.5 5.938h-3V22h21V5.938h-3v2.0078h1v12.0465h-17V7.9458h1V5.9381z"
  }), _react.default.createElement("path", {
    d: "M14.2144 3.2278c1.0097 1.0136 2.0195 2.0273 3.1609 3.3611l.0145.017.0138.0176c1.1457 1.4663 2.0961 3.2267 2.0961 5.3379h-2c0-1.4681-.6516-2.7914-1.6562-4.0814-1.0832-1.2644-2.0421-2.2275-3.0505-3.2398l1.4142-1.4197.0072.0073zM9.7072 19.1963c.9781-.9819 1.7541-1.6341 2.6562-2.0602.8906-.4208 1.9841-.6574 3.6367-.6574V14.471c-1.8475 0-3.2539.2653-4.4883.8484-1.2229.5777-2.197 1.4313-3.2188 2.4572l1.4142 1.4197z"
  })];
};

exports.default = _default;